import React from 'react';
import { Link } from "react-router-dom";
import {Undo2} from "lucide-react";
import thank from "../../images/img/Appreciation-bro.svg";

const Merci = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center" style={{ width: '480px' }}>
        <img src={thank} alt="" className="img-fluid" style={{ width: '260px' }} />
        <h1 className="mb-3">Merci pour votre inscription.</h1>
        <p className="mb-4">
          Merci de vous être inscrit(e) dans notre CV-thèque, nous reviendrons vers vous dans les meilleurs délais.
        </p>
        <Link
            to="/"
            className="btn btn-acc"
        >
            <Undo2 size={20} strokeWidth={1.5} /> Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default Merci;
